<template>
    <div class="cover-page" ref="screenWrapper">
        <div class="flex justify-end w-full mt-14">
            <img src="../../assets/images/year-in-review/cover.svg" class="post-card" alt="post-card" />
        </div>
        <div class="grid justify-center items-center mt-12 sm-h:mb-12 text-center">
            <img src="../../assets/images/year-in-review/caret-up.svg" class="mx-auto" alt="continue" />
            <p class="font-medium text-white font-satoshi_r">Get Started</p>
        </div>
    </div>
</template>

<script>
export default {
    mounted() {
        const screenWrapper = this.$refs.screenWrapper;
        const hammer = new Hammer(screenWrapper);

        hammer.on("tap", () => {
            if (this.currentScreen === 0) return;
            this.$emit("goForward");
        });
    },
};
</script>

<style scoped>
.post-card {
    max-height: 70vh;
    max-height: 70dvh;
    margin-inline: auto;
}

.cover-page {
    width: 100%;
    height: 100vh;
    min-height: 100vh;

    background-color: #3ba2df;
    background-image: url("../../assets/images/year-in-review/cover-bg.png");
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;

    display: flex;
    justify-content: center;
    flex-direction: column;
    background-size: cover;
}
</style>
